import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import './Detail.css';
import Modal from 'react-responsive-modal';
import 'react-responsive-modal/styles.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faExternalLinkAlt, faHeart, faUser, faCreditCard, faMoneyBillWave, faUserCheck, faEnvelope, faPaperPlane, faMaskFace, faAddressCard } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import baseURL from '../url';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DetailLoading from "../DetailLoading/DetailLoading";
import moneda from '../moneda';
import { Link as Anchor } from 'react-router-dom';
import { useMediaQuery } from '@react-hook/media-query';

// IMPORTACIÓN DEL NAVBAR

// colores #D2BCA1 #273F5B #7F715F #6F481C #A76825

import Navbar from '../Navbar/Navbar';

export default function Detail() {
    const navigate = useNavigate();
    const { idServicio } = useParams();
    const location = useLocation();
    const isScreenLarge = useMediaQuery('(min-width: 1024px)');
    const isMobile = useMediaQuery('(max-width: 640px)');
    const categoriasInputRef = useRef(null);

    // Estados de datos
    const [servicio, setServicio] = useState(null);
    const [loading, setLoading] = useState(true);
    const [categorias, setCategorias] = useState([]);
    const [subcategorias, setSubCategorias] = useState([]);
    const [favoritos, setFavoritos] = useState([]);
    const [serviciosSimilares, setServiciosSimilares] = useState([]);
    
    // Estados de UI
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalImage, setModalImage] = useState("");
    const [fixedCategories, setFixedCategories] = useState(false);
    const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(false);
    const [imagenActual, setImagenActual] = useState(0);
    const [mensaje, setMensaje] = useState("");

    // 1. Cargar datos iniciales
    useEffect(() => {
        const cargarDatosGlobales = async () => {
            try {
                const [resCat, resSub] = await Promise.all([
                    fetch(`${baseURL}/categoriasGet.php`).then(r => r.json()),
                    fetch(`${baseURL}/subCategoriaGet.php`).then(r => r.json())
                ]);
                setCategorias(resCat.categorias || []);
                setSubCategorias(resSub.subcategorias || []);
            } catch (error) {
                console.error('Error cargando datos maestros:', error);
            }
        };

        cargarDatosGlobales();
        setFavoritos(JSON.parse(localStorage.getItem('favoritos')) || []);

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // 2. Cargar servicio específico
    useEffect(() => {
        if (!idServicio) return;
        
        setLoading(true);
        window.scrollTo(0, 0);

        fetch(`${baseURL}/serviciosGet.php`)
            .then(response => response.json())
            .then(data => {
                const lista = data.servicios || [];
                const encontrado = lista.find(e => e.idServicio === parseInt(idServicio));
                setServicio(encontrado);

                if (encontrado) {
                    const filtrados = lista.filter(item => 
                        item.idCategoria === encontrado.idCategoria && 
                        item.idServicio !== encontrado.idServicio
                    );
                    const aleatorios = filtrados.sort(() => 0.5 - Math.random());
                    setServiciosSimilares(aleatorios);
                    setImagenActual(0);
                }

                setLoading(false);
            })
            .catch(error => {
                console.error('Error al cargar servicio:', error);
                setLoading(false);
            });
    }, [idServicio]);

    const handleScroll = () => {
        if (categoriasInputRef.current) {
            setFixedCategories(window.scrollY > categoriasInputRef.current.offsetTop);
        }
    };

    const handleCompartirClick = () => {
        if (navigator.share) {
            navigator.share({
                title: document.title,
                text: 'Echa un vistazo a este producto/servicio',
                url: window.location.href,
            }).catch(error => console.error('Error al compartir:', error));
        } else {
            toast.info('Enlace copiado al portapapeles');
        }
    };

    const handleWhatsappMessage = () => {
        const formattedPrice = Number(servicio?.precio).toLocaleString('es-ES', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        });
        const msg = `Hola 🌟, quisiera más información sobre: *${servicio?.titulo}*\n${moneda} ${formattedPrice}`;
        window.open(`https://api.whatsapp.com/send?phone=${servicio?.telefono}&text=${encodeURIComponent(msg)}`, '_blank');
    };

    const agregarAFavoritos = (id) => {
        const favList = [...favoritos];
        const index = favList.indexOf(id);
        if (index === -1) {
            favList.push(id);
        } else {
            favList.splice(index, 1);
        }
        setFavoritos(favList);
        localStorage.setItem('favoritos', JSON.stringify(favList));
    };

    const enviarWhatsAppPersonalizado = () => {
        const textToSend = mensaje.trim() !== "" 
            ? mensaje 
            : `Hola 🌟, quisiera consultar sobre: *${servicio?.titulo}*`;
        window.open(`https://wa.me/${servicio?.telefono}?text=${encodeURIComponent(textToSend)}`, "_blank");
    };

    const imagenes = [
        servicio?.imagen1,
        servicio?.imagen2,
        servicio?.imagen3,
        servicio?.imagen4
    ].filter(Boolean);

    if (loading || !servicio) {
        return <DetailLoading />;
    }

    // Búsqueda de categoría
    const categoriaEncontrada = categorias.find(
        cat => String(cat.idCategoria) === String(servicio.idCategoria)
    );

    // Formateador de moneda
    const formatPrecio = (valor) => {
        return `${moneda}${String(Math.round(valor || 0)).replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`;
    };

    // --- REGLAS DE NEGOCIO Y FINANCIACIÓN ---
    const precioBase = Number(servicio.precio) || 0;
    
    // Tarjeta de crédito
    const cuotas3 = (precioBase * 0.85) / 3;   // 15% OFF
    const cuotas6 = (precioBase * 0.90) / 6;   // 10% OFF
    const cuotas12 = (precioBase * 0.95) / 12; // 5% OFF
    const cuotas18 = precioBase / 18;          // Sin interés

    // Crédito personal
    const cuotasCredito12 = precioBase / 12;   // Sin interés

    // Efectivo / Transferencia
    const precioEfectivo = precioBase * 0.80;  // 20% OFF

    return (
        <div style={{ fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" }}>
            <Navbar />
            <ToastContainer />
            
            <div className="detail" style={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}>
                
                {/* BOTÓN VOLVER */}
                <div className={`deFlexDetail ${fixedCategories ? 'fixedHeader' : ''}`} ref={categoriasInputRef} style={{ padding: '15px 20px 0 20px' }}>
                    <button className="back" onClick={() => location.key !== 'default' ? navigate(-1) : navigate('/')}> 
                        <FontAwesomeIcon icon={faArrowLeft} /> 
                    </button>
                </div>

                {/* CONTENIDO PRINCIPAL */}
                <div className="detail-contain" style={{
                    display: 'flex',
                    flexDirection: isScreenLarge ? 'row' : 'column',
                    gap: isScreenLarge ? '40px' : '24px',
                    alignItems: 'flex-start',
                    marginTop: '10px',
                    padding: isScreenLarge ? '20px 40px 40px 40px' : '0 15px 20px 15px',
                    maxWidth: '1280px',
                    marginRight: 'auto',
                    marginLeft: 'auto',
                    width: '100%',
                    boxSizing: 'border-box'
                }}>
                    
                    {/* COLUMNA IZQUIERDA: Galería Ajustada */}
                    <div className="leftColumn" style={{ flex: isScreenLarge ? '1.1' : 'none', width: '100%' }}>
                        <div className="galleryPreview" style={{ display: 'flex', flexDirection: 'column', gap: '12px', width: '100%' }}>
                            
                            {/* Imagen Principal 1:1 con cover */}
                            <div className="galleryMain" style={{ 
                                position: 'relative', 
                                display: 'flex', 
                                alignItems: 'center', 
                                justifyContent: 'center',
                                width: '100%',
                                aspectRatio: '1 / 1',
                                overflow: 'hidden',
                                borderRadius: '16px',
                                backgroundColor: '#f8fafc',
                                border: '1px solid #f1f5f9'
                            }}>
                                {imagenes.length > 1 && (
                                    <button type="button" className="galleryArrow left" 
                                        onClick={() => setImagenActual(prev => prev === 0 ? imagenes.length - 1 : prev - 1)}
                                        style={{ position: 'absolute', left: '12px', zIndex: '10', background: 'rgba(255,255,255,0.85)', border: 'none', cursor: 'pointer', borderRadius: '50%', padding: '10px', display: 'flex', backdropFilter: 'blur(4px)' }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#334155" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                            <polyline points="15 18 9 12 15 6"></polyline>
                                        </svg>
                                    </button>
                                )}

                                <img 
                                    src={imagenes[imagenActual]} 
                                    className="galleryImage" 
                                    alt={servicio.titulo}
                                    style={{ 
                                        width: '100%', 
                                        height: '100%', 
                                        objectFit: 'cover',
                                        cursor: 'pointer',
                                        transition: 'all 0.3s ease'
                                    }}
                                    onClick={() => { setModalImage(imagenes[imagenActual]); setIsModalOpen(true); }} 
                                />

                                {imagenes.length > 1 && (
                                    <button type="button" className="galleryArrow right" 
                                        onClick={() => setImagenActual(prev => prev === imagenes.length - 1 ? 0 : prev + 1)}
                                        style={{ position: 'absolute', right: '12px', zIndex: '10', background: 'rgba(255,255,255,0.85)', border: 'none', cursor: 'pointer', borderRadius: '50%', padding: '10px', display: 'flex', backdropFilter: 'blur(4px)' }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#334155" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                            <polyline points="9 18 15 12 9 6"></polyline>
                                        </svg>
                                    </button>
                                )}
                            </div>
                            
                            {/* Miniaturas centradas y ajustadas exactamente al ancho */}
                            {imagenes.length > 0 && (
                                <div style={{ 
                                    display: 'grid', 
                                    gridTemplateColumns: 'repeat(4, 1fr)', 
                                    gap: '10px', 
                                    width: '100%' 
                                }}>
                                    {imagenes.map((img, index) => (
                                        <div 
                                            key={index}
                                            onClick={() => setImagenActual(index)}
                                            style={{
                                                aspectRatio: '1 / 1',
                                                borderRadius: '10px',
                                                overflow: 'hidden',
                                                cursor: 'pointer',
                                                border: imagenActual === index ? '2px solid #D2BCA1' : '1px solid #e2e8f0',
                                                opacity: imagenActual === index ? 1 : 0.7,
                                                transition: 'all 0.2s ease',
                                                backgroundColor: '#f8fafc'
                                            }}
                                        >
                                            <img 
                                                src={img} 
                                                alt={`thumbnail-${index}`} 
                                                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                            />
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>

                    {/* COLUMNA DERECHA: Tipografía minimalista y Tarjeta de Contacto Rediseñada */}
                    <div className="rightColumn" style={{ flex: isScreenLarge ? '0.9' : 'none', width: '100%', display: 'flex', flexDirection: 'column', gap: '16px' }}>
                        
                        {/* Título e Iconos */}
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '16px' }}>
                            <h1 style={{ fontSize: isMobile ? '22px' : '26px', fontWeight: '400', color: '#0f172a', margin: 0, lineHeight: '1.3', letterSpacing: '-0.02em' }}>
                                {servicio.titulo}
                            </h1>
                            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                <button onClick={() => agregarAFavoritos(servicio.idServicio)} style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '50%', width: '38px', height: '38px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
                                    <FontAwesomeIcon icon={faHeart} style={{ color: favoritos.includes(servicio.idServicio) ? '#d2bca1' : '#94a3b8', fontSize: '15px' }} />
                                </button>
                                <button onClick={handleCompartirClick} style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '50%', width: '38px', height: '38px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}> 
                                    <FontAwesomeIcon icon={faExternalLinkAlt} style={{ color: '#64748b', fontSize: '14px' }} /> 
                                </button>
                            </div>
                        </div>

                        {/* Precio Principal */}


                        

                        {/* Descripción Minimalista */}
                        <div style={{ marginTop: '4px' }}>
                            <span onClick={() => !isScreenLarge && setIsDescriptionExpanded(!isDescriptionExpanded)} 
                                  style={{ color: '#64748b', fontSize: '13px', lineHeight: '1.6', fontWeight: '300' }}>
                                {isScreenLarge || isDescriptionExpanded 
                                    ? servicio.descripcion 
                                    : `${servicio.descripcion.substring(0, 200)}${servicio.descripcion.length > 200 ? '...' : ''}`
                                }
                                {!isScreenLarge && servicio.descripcion.length > 200 && (
                                    <span style={{ fontWeight: '500', color: '#006ce4', cursor: 'pointer' }}>
                                        {isDescriptionExpanded ? " Ver menos" : " Ver más"}
                                    </span>
                                )}
                            </span>
                        </div>

                        {/* TARJETA UNIFICADA DE CONTACTO (REDISEÑO EXACTO SEGÚN IMAGEN) */}
                        <div style={{
                            backgroundColor: '#f8fafc',
                            borderRadius: '16px',
                            border: '1px solid #e2e8f0',
                            padding: '18px',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '14px',
                            marginTop: '8px',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.02)'
                        }}>
                            <h3 style={{ fontSize: '15px', fontWeight: '600', color: '#0f172a', margin: 0 }}>
                                Iniciá tu consulta por WhatsApp
                            </h3>

                            {/* FILA DE CATEGORÍA Y BOTONES DIRECTOS */}
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
                                
                                {/* Información de Categoría */}
                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <div style={{ background: '#cbd5e1', borderRadius: '50%', width: '34px', height: '34px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                        <FontAwesomeIcon icon={faAddressCard} style={{ color: '#fff', fontSize: '14px' }} />



                                    </div>
                                    <div>
                                        <h4 style={{ margin: 0, fontSize: '11px', color: '#64748b', fontWeight: '500', textTransform: 'uppercase', letterSpacing: '0.03em' }}>
                                            Categoría
                                        </h4>
                                        {categoriaEncontrada ? (

                                                <h5 style={{ cursor: 'pointer', color: '#0f172a', margin: 0, fontSize: '10px', fontWeight: '600' }}>
                                                    {categoriaEncontrada.categoria.toUpperCase()}
                                                </h5>
                                           
                                        ) : (
                                            <h5 style={{ margin: 0, fontSize: '10px', fontWeight: '600' }}>Cargando...</h5>
                                        )}
                                    </div>
                                    


                                    <div>
                                        <h4 style={{ margin: 0, fontSize: '11px', color: '#64748b', fontWeight: '500', textTransform: 'uppercase', letterSpacing: '0.03em' }}>
                                            Responsable
                                        </h4>
                                                    <h5 style={{ cursor: 'pointer', color: '#0f172a', margin: 0, fontSize: '10px', fontWeight: '600' }}>
                                                            {servicio.nombre}
                                                    </h5>
                                                    </div>
                                </div>

                                {/* Botones Rápidos de Email y WhatsApp */}

                                
                                <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                   {/*  <Anchor 
                                        to={`mailto:${servicio.email}`} 
                                        style={{ 
                                            textDecoration: 'none', 
                                            padding: '8px 14px', 
                                            borderRadius: '10px', 
                                            backgroundColor: '#dbeafe', 
                                            color: '#1d4ed8', 
                                            fontSize: '13px', 
                                            fontWeight: '500',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '6px'
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faEnvelope} />
                                        <span>Email</span>
                                    </Anchor>
                                */}

                                </div>
                            </div>

                            {/* CONTENEDOR DE TEXTAREA Y BOTÓN DE ENVÍO */}
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                <div style={{ position: 'relative', width: '100%' }}>
                                    <textarea
                                        placeholder="Enviar mensaje por WhatsApp"
                                        value={mensaje}
                                        onChange={(e) => setMensaje(e.target.value)}
                                        style={{ 
                                            width: '100%', 
                                            borderRadius: '10px', 
                                            border: '1px solid #cbd5e1', 
                                            padding: '12px 35px 12px 12px', 
                                            fontSize: '13px', 
                                            fontFamily: 'inherit', 
                                            resize: 'vertical', 
                                            minHeight: '70px',
                                            outline: 'none',
                                            boxSizing: 'border-box',
                                            backgroundColor: '#fff'
                                        }}
                                    />
                                    <FontAwesomeIcon 
                                        icon={faWhatsapp} 
                                        style={{ position: 'absolute', right: '12px', top: '14px', color: '#25D366', fontSize: '18px' }} 
                                    />
                                </div>
                                
                                <button 
                                    onClick={enviarWhatsAppPersonalizado}
                                    style={{
                                        width: '100%',
                                        backgroundColor: '#00cc77',
                                        color: 'white',
                                        border: 'none',
                                        padding: '12px 16px',
                                        borderRadius: '10px',
                                        cursor: 'pointer',
                                        fontWeight: '500',
                                        fontSize: '14px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        textAlign: 'center',
                                        gap: '8px',
                                        margin: '0 auto',
                                        boxSizing: 'border-box',
                                        transition: 'background 0.2s ease'
                                    }}
                                >
                                    <span>Enviar Consulta por WhatsApp</span>
                                    <FontAwesomeIcon icon={faPaperPlane} style={{ fontSize: '12px' }} />
                                </button>

                                                                 <div className="cardServicioText">
                                                            <span> <i className="fa fa-map-marker"></i> {servicio.direccion}</span>
                                                        </div>                       
                            </div>
                        </div>

                    </div>
                </div>

                {/* SECCIÓN PRODUCTOS RELACIONADOS */}
                {serviciosSimilares.length > 0 && (
                    <div className="similarServicesSection" style={{ width: '100%', marginTop: '40px', padding: isScreenLarge ? '20px 40px' : '20px 15px', maxWidth: '1280px', margin: '40px auto 0 auto', boxSizing: 'border-box' }}>
                        <h3 style={{ fontSize: '18px', marginBottom: '20px', fontWeight: '400', color: '#0f172a', letterSpacing: '-0.01em' }}>
                            Productos relacionados
                        </h3>
                        
                        <div className="carouselWrapper" style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                            <div 
                                id="similarServicesGrid"
                                style={{
                                    display: 'grid',
                                    gridAutoFlow: 'column',
                                    gridAutoColumns: isScreenLarge ? 'calc(25% - 15px)' : isMobile ? 'calc(80% - 10px)' : 'calc(40% - 10px)',
                                    gap: '16px',
                                    width: '100%',
                                    overflowX: 'auto',
                                    scrollBehavior: 'smooth',
                                    padding: '4px 2px',
                                    scrollbarWidth: 'none',
                                    msOverflowStyle: 'none'
                                }}
                            >
                                {serviciosSimilares.map((simi) => (
                                    <Anchor 
                                        key={simi.idServicio}
                                        to={`/servicio/${simi.idServicio}/${simi.titulo.trim().replace(/\s+/g, '-').replace(/[^a-zA-Z0-9-]/g, '')}`}
                                        style={{
                                            textDecoration: 'none', color: 'inherit', background: '#fff',
                                            borderRadius: '12px', overflow: 'hidden', border: '1px solid #f1f5f9',
                                            display: 'flex', flexDirection: 'column', position: 'relative'
                                        }}
                                    >
                                        <div style={{ width: '100%', aspectRatio: '1/1', overflow: 'hidden', background: '#f8fafc' }}>
                                            <img 
                                                src={simi.imagen1} 
                                                alt={simi.titulo} 
                                                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                            />
                                        </div>

                                        <div style={{ padding: '12px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                                            <h4 style={{ fontSize: '13px', margin: 0, fontWeight: '400', color: '#334155', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                {simi.titulo}
                                            </h4>
                                            <p style={{ fontSize: '14px', margin: 0, fontWeight: '500', color: '#006ce4' }}>
                                    
                                                            <span> <i className="fa fa-map-marker"></i> {servicio.direccion}</span>
                                            </p>

                                        </div>
                                    </Anchor>
                                ))}
                            </div>
                        </div>
                    </div>
                )}

                {/* MODAL DE IMAGEN */}
                <Modal open={isModalOpen} onClose={() => setIsModalOpen(false)} center classNames={{ modal: 'custom-modal' }}>
                    <img 
                        src={modalImage} 
                        alt={servicio.titulo} 
                        onClick={() => setIsModalOpen(false)}
                        style={{ maxWidth: '100%', height: 'auto', cursor: 'pointer', borderRadius: '8px' }} 
                    />
                </Modal>
            </div>
        </div>
    );
}